import { render, staticRenderFns } from "./SentimentUpLimit.vue?vue&type=template&id=0bb36ed8&scoped=true"
import script from "./SentimentUpLimit.vue?vue&type=script&lang=js"
export * from "./SentimentUpLimit.vue?vue&type=script&lang=js"
import style0 from "./SentimentUpLimit.vue?vue&type=style&index=0&id=0bb36ed8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb36ed8",
  null
  
)

export default component.exports